import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: '50%',
    margin: '30px auto',
    display: 'flex',
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    padding: '30px',
    boxSizing: 'border-box',
    flexDirection: 'column',
    gap: '10px',
  },
}));

export default useStyles;
